var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("router-view", { on: { updateResource: _vm.updateSerie } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }